// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3BQIw","description":"PatientConsentPreview_description__2vwuE"};